import { trackingEvents } from '@/mocks/homeData';

const statusStyle: Record<string, string> = {
  跟进中: 'bg-accent-100 text-accent-800',
  基本清晰: 'bg-primary-100 text-primary-800',
  待补充: 'bg-secondary-100 text-secondary-900',
};

export default function TrackingList() {
  return (
    <section id="track" className="rounded-lg border border-background-200 bg-background-50 p-5">
      <div className="flex items-center justify-between">
        <h2 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
          <i className="ri-route-line text-primary-600"></i>
          事件进度追踪
        </h2>
        <span className="font-label text-xs text-foreground-500">{trackingEvents.length} 项在跟进</span>
      </div>

      <ul className="mt-5 space-y-5">
        {trackingEvents.map((event) => (
          <li key={event.id}>
            <div className="flex items-start justify-between gap-3">
              <h3 className="font-label text-sm font-medium leading-snug text-foreground-900">
                {event.title}
              </h3>
              <span
                className={`shrink-0 whitespace-nowrap rounded-full px-2.5 py-0.5 font-label text-xs ${
                  statusStyle[event.status] ?? 'bg-background-100 text-foreground-700'
                }`}
              >
                {event.status}
              </span>
            </div>
            <div className="mt-2.5 h-1.5 w-full overflow-hidden rounded-full bg-background-200">
              <div
                className="h-full animate-grow rounded-full bg-primary-500"
                style={{ width: `${event.progress}%` }}
              ></div>
            </div>
            <div className="mt-2 flex items-center justify-between font-label text-xs text-foreground-500">
              <span>{event.stage}</span>
              <span>{event.update}</span>
            </div>
          </li>
        ))}
      </ul>

      <a
        href="#track"
        className="mt-5 flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-background-100 py-2.5 font-label text-sm text-foreground-800 transition-colors hover:bg-background-200 cursor-pointer"
      >
        查看全部进度
        <i className="ri-arrow-right-line text-base"></i>
      </a>
    </section>
  );
}